var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('accommodation-category-form',{model:{value:(_vm.accommodationCategory),callback:function ($$v) {_vm.accommodationCategory=$$v},expression:"accommodationCategory"}})}
var staticRenderFns = []

export { render, staticRenderFns }